// Vue Plugins
import vue from 'vue';
import v2s from 'vue-script2';
import notification from '@/utils/notification';
import store from '@/store';
import common from '@/mixins/common';

// Vue Components
import compareBar from '@/components/containers/plp/CompareBar';
import compareRackContainer from '@/components/compare/CompareRackContainer';
import TrekButton from '@/components/TrekButton';
import TrekLink from '@/components/TrekLink';
import TrekFooter from '@/components/TrekFooter';

// Vue Nav Components
import NavApp from '@/navigation/NavApp';
import NavLargeContainer from '@/navigation/containers/NavLargeContainer';
import NavCategoriesLayout from '@/navigation/layouts/NavCategoriesLayout';
import NavCategoriesLink from '@/navigation/components/NavCategoriesLink';
import NavCompactContainer from '@/navigation/containers/NavCompactContainer';
import NavOverlayCompactLayout from '@/navigation/layouts/NavOverlayCompactLayout';
import NavUtilityBarB2cContainer from '@/navigation/containers/NavUtilityBarB2cContainer';

// Vue components used site-wide
import {nonCriticalCssLoader} from '@/entryPoints/lib/non-critical-css-loader';
import liveChat from '@/modules/liveChat';
import menuSelector from '@/modules/MenuSelector';
import miniCart from '@/modules/MiniCart';
import explodingAccordion from '@/modules/explodingAccordion';
import loadingIndicator from '@/modules/loadingIndicator';
import emailSignup from '@/modules/EmailSignup';
import geoPrompt from '@/modules/geoPrompt';

// Utils
import '@/utils/axios/index';
import {updateASMHeader} from '@/utils/asmAdjustments';
import toggler from '@/modules/Toggler';

// Directives
import DebugHighlight from '@/directives/debug-highlight.directive';

//Misc
import editorialHighlightComponent from '@/modules/editorialHighlightComponent';

class ShellBase {
  /**
   * Initialize a new instance of the ShellBase class.
   * @param pageComponents
   */
  constructor(pageComponents = {}, vueRouter = {}) {
    this.vue = vue;
    this.store = store;
    this.pageComponents = pageComponents;
    this.router = vueRouter;

    vue.config.devtools = !window.ACC.config.isProduction;
    vue.config.silent = window.ACC.config.isProduction;

    // Directives
    vue.directive('debug-highlight', DebugHighlight);

    // // Set dynamic path for webpack chunks.
    if (!window.webpackHotUpdate) {
      const cdnDynamicFilesRoot = window.ACC.config.cdnDynamicFilesRoot;
      // eslint-disable-next-line no-undef
      __webpack_public_path__ = `${cdnDynamicFilesRoot}${!cdnDynamicFilesRoot.endsWith('/') ? '/' : ''}`;
    }
  }

  /**
   * Register a list of components in a global context.
   * @param components
   */
  registerVueComponents(components) {
    if (!components || !Object.keys(components).length) {
      return;
    }

    Object.keys(components).forEach((name) => {
      const component = components[name];
      this.vue.component(name, component.default || component);
    });
  }

  /**
   * Initialize Vue
   */
  initializeVue() {
    this.loadPlugins();

    const vm = new vue({
      router: this.router,
      store,
      el: '#page',
      components: {
        ...this.pageComponents,
        compareBar,
        compareRackContainer,
        TrekButton,
        TrekLink,
        TrekFooter,
        NavApp,
        NavLargeContainer,
        NavCategoriesLayout,
        NavCategoriesLink,
        NavCompactContainer,
        NavOverlayCompactLayout,
        NavUtilityBarB2cContainer,
      },
      methods: {
        toast(options) {
          this.$notify(options);
        },

        mounted() {
          if (this.$validator) {
            this.$validator.localize(this.$store.state.vvLocale);
          }
        },
      },
    });

    store.commit('backend/setB2b', window.ACC.isB2Bsite);
    window.store = store;
    window.toast = vm.toast;
    window.vm = vm;
  }

  loadPlugins() {
    // Load common plugins here
    vue.use(v2s);
    vue.mixin(common);
    vue.prototype.$notify = notification;
  }

  preLoadInits() {
    nonCriticalCssLoader();
  }

  globalDocumentReadyInits() {
    // adding a global loading indicator
    window.loadingIndicator = loadingIndicator();

    // Live Chat
    liveChat();

    // Enables top nav interactions
    menuSelector($(document));

    // ASM Adjustments
    updateASMHeader();

    // Collapsing blocks handler
    const togglers = $('[data-toggler]');
    togglers.each((i, t) => {
      toggler($(t));
    });

    // Geo Prompt
    if ($('.geo-prompt-modal').length) {
      geoPrompt();
    }

    // Footer Email Sign Up Script
    emailSignup();
  }

  globalOnLoadInits() {
    $(window).trigger('resize');
    miniCart(document);

    // Footer expanding accordions in mobile
    const explodingAccordions = $(document).find('[data-accordion-explode]');
    explodingAccordions.each((i, t) => {
      explodingAccordion($(t));
    });

    //Check if editorialHighLightComponet is present in page
    if ($('.js-editorial-highlight-component').length) {
      editorialHighlightComponent();
    }
  }
}

export {ShellBase};
